<script>
import { GlobalBus } from '@services/bus'
import { ACTIONS, CANT_ACCESS_FUNCTION } from '@constants/Text'
import LineItem from '@components/resumo/line-item'

export default {
  components: {
    LineItem,
  },
  props: {
    clienteModal: {
      type: Object,
      required: false,
    },
    hideDescription: Boolean,
  },
  data() {
    return {}
  },
  computed: {
    cliente() {
      return this.clienteModal || this.$currentClient()
    },
    status() {
      return this.$store.getters['clientStatus/status']
    },
    estrutura() {
      return this.$store.getters['clientStatus/estrutura']
    },
    loadingEstrutura() {
      return this.$store.getters['clientStatus/infoEstrutura'].loading
    },
  },
  created() {
    this.$store.dispatch('clientStatus/carregar', this.cliente)
    GlobalBus.$on('changeClient', this.changeClient)
  },
  methods: {
    changeClient() {
      this.$store.dispatch('clientStatus/carregar', this.cliente)
    },
    goTo(name) {
      if (!this.$canAccessRoute(name)) {
        this.$showSnack({
          text: CANT_ACCESS_FUNCTION,
          button: true,
        })
        return
      }
      if (name && this.$route.name !== name) {
        if (this.$currentClient().id !== this.cliente.id) {
          this.$store.dispatch('user/addSearchClient', { ...this.cliente })
        }

        this.$router.push({ name })

        GlobalBus.$emit(ACTIONS.CLOSE_RESUME)
      }
    },
  },
}
</script>

<template>
  <div>
    <div class="v-application">
      <template v-for="(item, index) in status">
        <v-divider
          v-if="index > 0"
          :style="{
            'border-top-width': '10px !important',
            'border-color': item.disabled
              ? 'var(--secondary) !important'
              : `var(--${item.color}) !important`,
            'margin-top': '14px !important',
          }"
        />
        <LineItem
          :item="item"
          :dados="estrutura"
          :hideDescription="hideDescription"
          @goto="goTo"
        />
      </template>
    </div>
    <div v-if="loadingEstrutura">
      <v-progress-linear rounded indeterminate color="primary" />
    </div>
  </div>
</template>
